import axios from 'axios';
import Cookies from 'js-cookie';
import { handleInitialAuthorizationError } from './refreshToken';

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  validateStatus: (status) => status < 400, // Resolve only if the status code is less than 400
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'X-Requested-With, content-type, Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
    'Access-Control-Allow-Credentials': 'true',
  },
});

http.interceptors.request.use(
  async function (request) {
    const authorization = Cookies.get('jwtToken');

    if (authorization) {
      request.headers.Authorization = `Bearer ${authorization}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  async function (response) {
    return Promise.resolve(response);
  },
  async function (error) {
    return await handleInitialAuthorizationError(error);
  }
);
